export default "__VITE_ASSET__e7b5e4dc__"